import { useSentry } from '../composables/sentry'

export function buildFilterString(payload: any): string {
  const { handleError } = useSentry()
  try {
    let filterString = ''
    if (!Object.keys(payload).length)
      return filterString
    const stringSections = []
    for (const key of Object.keys(payload)) {
      let r = Array.from(payload[key])
      // Wrap each value in ``
      // '`' is required when filter strings have non URI encoding characters like a '(' and ')'
      r = r.map((_r: any) => {
        if (['true', 'false'].includes(_r))
          return _r
        return `\`${_r}\``
      })
      stringSections.push(`${key}:=[${r.join(',')}]`)
    }
    filterString = stringSections.join(' && ')
    return filterString
  }
  catch (error: any) {
    handleError(error)
    return ''
  }
}
